<template>
  <!-- Botón flotante: Olivia "en línea", lleva al asistente (desktop) -->
  <button
    class="olivia-fab hidden lg:flex fixed bottom-6 right-6 z-40 w-16 h-16 rounded-full bg-gradient-to-br from-purple-600 to-indigo-600 shadow-[0_0_18px_rgba(99,102,241,0.5)] items-center justify-center transition-transform duration-300 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-indigo-300"
    @click="abrirAsistente"
    title="Hablar con Olivia"
  >
    <!-- Anillo de "llamada" muy sutil -->
    <span class="olivia-ring absolute inset-0 rounded-full"></span>
    <span class="w-11 h-11 relative z-10">
      <OliviaAvatar animated />
    </span>
    <!-- Punto verde de disponible -->
    <span class="absolute bottom-1 right-1 z-20 w-3.5 h-3.5 rounded-full bg-emerald-500 border-2 border-background"></span>
  </button>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import OliviaAvatar from '@/components/OliviaAvatar.vue';

const router = useRouter();

const abrirAsistente = () => {
  if (router.currentRoute.value.name !== 'Asistente') {
    router.push({ name: 'Asistente' });
  }
};

// El BottomNavBar (móvil) sigue emitiendo este evento; ahora navega a la página
onMounted(() => {
  window.addEventListener('open-ai-chat', abrirAsistente);
});
onBeforeUnmount(() => {
  window.removeEventListener('open-ai-chat', abrirAsistente);
});
</script>

<style scoped>
/* Latido suave del botón, evoca una llamada disponible sin ser insistente */
.olivia-fab {
  animation: olivia-latido 3s ease-in-out infinite;
}
@keyframes olivia-latido {
  0%, 100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.45); }
  70% { box-shadow: 0 0 0 12px rgba(99, 102, 241, 0); }
}
.olivia-fab:hover { animation: none; }

/* Anillo tenue que se expande, como un tono de llamada */
.olivia-ring {
  border: 2px solid rgba(255, 255, 255, 0.4);
  animation: olivia-anillo 3s ease-out infinite;
}
@keyframes olivia-anillo {
  0% { transform: scale(1); opacity: 0.5; }
  70%, 100% { transform: scale(1.35); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .olivia-fab, .olivia-ring { animation: none; }
}
</style>
